import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { IGridResult } from 'src/app/core/models/base';
import { IOrder } from '../models/order';
import { OrderService } from '../services/order.service';

@Injectable({
  providedIn: 'root'
})
export class AdminOrdersResolver  {
  constructor(private orderService: OrderService){}

  resolve(
    route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot
    ): Observable<IGridResult<IOrder[]>> {
    return this.orderService.listorders({pageNumber: 0, pageSize: 25, orderBy:["createdOn desc"]})
      .pipe(
        map(response => {
          return {
            data: response.data,
            total: response.totalCount
          };
        })
      )
  }
}
